<template>
  <p
    v-if="isDisplay"
    class="m3p_mb5 m3p_fs-s text-danger m3p_table-form_name-error"
  >
    {{ message }}
  </p>
</template>

<script setup>
import { useErrorMessage } from "@component_path/inquiry_form_common_module/custom_hook/ErrorMessage.js";
import { useFieldError } from "vee-validate";

const props = defineProps({
  itemName: {
    type: String,
    required: true
  }
});

const message = useFieldError(props.itemName);
const { isDisplay } = useErrorMessage();
</script>
